module.exports = __webpack_public_path__ + "img/1FJ_pt_50xA6dNq141iK6anFFLuBbNain.c0f1cbea.png";